import { makeStyles } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { SizeType } from 'src/common/enumerations/cashier-preference-level';
import CashierPreferencesHelper from 'src/common/helpers/cashier-preferences-helper';
import { px, rem } from 'src/common/helpers/dimension-helper';
import { ButtonType } from './types';

const baseHeight = 7.29;
const baseWidth = 8.12;

const scaledFontSize = {
  '@media (max-height: 900px)': {
    fontSize: rem(1),
  },
  '@media (max-height: 768px)': {
    fontSize: rem(0.75),
  },
  '@media (max-height: 576px)': {
    fontSize: rem(0.625),
  },
};

interface PassedProps {
  size: SizeType;
  buttonType: ButtonType;
  noMax?: boolean;
  isSquare?: boolean;
}

const getButtonColors = (buttonType = 'default', theme): CSSProperties => {
  switch (buttonType) {
    case 'white':
      return {
        background: theme.white,
        '&:hover': {
          background: theme.white,
          boxShadow: 'none',
        },
        '&.Mui-disabled': {
          background: theme.white,
          opacity: 0.4,
          cursor: 'default',
        },
      };
    case 'alternate':
      return {
        background: theme.verylightgrey,
        '&:hover': {
          background: theme.verylightgrey,
          boxShadow: 'none',
        },
        '&.Mui-disabled': {
          background: theme.verylightgrey,
          cursor: 'default',
        },
      };
    case 'default':
    default: {
      const background = theme?.configColors?.primaryColor || theme.primaryMain;
      const color = theme?.configColors?.primaryText || theme.white;
      return {
        color,
        background,
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        border: 'none',
        '&:hover': {
          color,
          background,
        },
        '&.Mui-disabled': {
          cursor: 'default',
          opacity: 0.4,
          color,
          background,
        },
      };
    }
  }
};

// Until the theme gets typed...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const styles = makeStyles((theme: any) => ({
  root: ({ size, buttonType, noMax, isSquare }: PassedProps): any => {
    const height = `${baseHeight * CashierPreferencesHelper.sizeMultiplier(size)}vh`;
    const minWidth = `${baseWidth * CashierPreferencesHelper.sizeMultiplier(size)}vw`;
    const fontSize = `${CashierPreferencesHelper.sizeMultiplier(size || 0) * 1.13}rem`;
    const scalesFontSizes = noMax ? '' : scaledFontSize;
    return {
      // Styles are based off @ncr-retail/base-retail-components with all of the !importants removed
      color: theme.almostblack,
      border: `1px solid ${theme.lightgray}`,
      boxShadow: `0px 1px 2px ${theme.verylightgrey}`,
      textTransform: 'uppercase',
      borderRadius: '2px',
      fontSize: size || size === 0 ? fontSize : rem(1.13),
      letterSpacing: px(1.43),
      height,
      minHeight: height,
      minWidth: isSquare ? height : minWidth,
      ...scalesFontSizes,
      ...getButtonColors(buttonType, theme),
    };
  },
}));
